import { render } from "./UpdateReviewView.vue?vue&type=template&id=2ededc23"
import script from "./UpdateReviewView.vue?vue&type=script&lang=js"
export * from "./UpdateReviewView.vue?vue&type=script&lang=js"

import "./UpdateReviewView.vue?vue&type=style&index=0&id=2ededc23&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__